// Reutiliza o identificador após falha de rede; não guarda dados de cartão.
export async function fetchCheckoutPlano(url, options) {
  const body = JSON.parse(options.body);
  const key = `pc_checkout_pending:${body.plano}:${body.couponCode || ""}`;
  let requestId;
  try { requestId = sessionStorage.getItem(key); } catch {}
  requestId ||= crypto.randomUUID();
  try { sessionStorage.setItem(key, requestId); } catch {}
  const response = await fetch(url, { ...options, body: JSON.stringify({ ...body, requestId }) });
  if (response.ok || (response.status >= 400 && response.status < 500)) {
    try { sessionStorage.removeItem(key); } catch {}
  }
  return response;
}
